/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActivityEvent } from './ActivityEvent';
import {
    ActivityEventFromJSON,
    ActivityEventFromJSONTyped,
    ActivityEventToJSON,
    ActivityEventToJSONTyped,
} from './ActivityEvent';
import type { ClaimStatusCount } from './ClaimStatusCount';
import {
    ClaimStatusCountFromJSON,
    ClaimStatusCountFromJSONTyped,
    ClaimStatusCountToJSON,
    ClaimStatusCountToJSONTyped,
} from './ClaimStatusCount';
import type { ClaimTask } from './ClaimTask';
import {
    ClaimTaskFromJSON,
    ClaimTaskFromJSONTyped,
    ClaimTaskToJSON,
    ClaimTaskToJSONTyped,
} from './ClaimTask';

/**
 * 
 * @export
 * @interface WorkspaceAnalytics
 */
export interface WorkspaceAnalytics {
    /**
     * Total number of completed comparisons
     * @type {number}
     * @memberof WorkspaceAnalytics
     */
    comparisonsCount: number;
    /**
     * Total number of supplements created
     * @type {number}
     * @memberof WorkspaceAnalytics
     */
    supplementsCount: number;
    /**
     * 
     * @type {Array<ClaimStatusCount>}
     * @memberof WorkspaceAnalytics
     */
    claimsByStatus: Array<ClaimStatusCount>;
    /**
     * 
     * @type {Array<ClaimTask>}
     * @memberof WorkspaceAnalytics
     */
    upcomingTasks: Array<ClaimTask>;
    /**
     * 
     * @type {Array<ActivityEvent>}
     * @memberof WorkspaceAnalytics
     */
    recentActivities: Array<ActivityEvent>;
    /**
     * Time saved on comparisons in seconds
     * @type {number}
     * @memberof WorkspaceAnalytics
     */
    timeSavedComparisons: number;
    /**
     * Time saved on supplements in seconds
     * @type {number}
     * @memberof WorkspaceAnalytics
     */
    timeSavedSupplements: number;
    /**
     * AI processing time for comparisons in seconds
     * @type {number}
     * @memberof WorkspaceAnalytics
     */
    aiTimeComparisons: number;
    /**
     * AI processing time for supplements in seconds
     * @type {number}
     * @memberof WorkspaceAnalytics
     */
    aiTimeSupplements: number;
    /**
     * Estimated manual time for comparisons in seconds
     * @type {number}
     * @memberof WorkspaceAnalytics
     */
    manualTimeComparisons: number;
    /**
     * Estimated manual time for supplements in seconds
     * @type {number}
     * @memberof WorkspaceAnalytics
     */
    manualTimeSupplements: number;
    /**
     * Total carrier overscope in dollars
     * @type {number}
     * @memberof WorkspaceAnalytics
     */
    totalCarrierOverscope: number;
    /**
     * Total missed items value in dollars
     * @type {number}
     * @memberof WorkspaceAnalytics
     */
    totalMissedItems: number;
    /**
     * Potential commission in dollars
     * @type {number}
     * @memberof WorkspaceAnalytics
     */
    potentialCommission: number;
    /**
     * Total insurance RCV in dollars
     * @type {number}
     * @memberof WorkspaceAnalytics
     */
    totalInsuranceRCV: number;
    /**
     * Total contractor RCV in dollars
     * @type {number}
     * @memberof WorkspaceAnalytics
     */
    totalContractorRCV: number;
    /**
     * Difference between contractor and insurance RCV in dollars
     * @type {number}
     * @memberof WorkspaceAnalytics
     */
    totalRCVDifference: number;
    /**
     * Average variance amount in dollars
     * @type {number}
     * @memberof WorkspaceAnalytics
     */
    averageVarianceAmount?: number;
    /**
     * Average variance percentage
     * @type {number}
     * @memberof WorkspaceAnalytics
     */
    averageVariancePercent?: number;
}

/**
 * Check if a given object implements the WorkspaceAnalytics interface.
 */
export function instanceOfWorkspaceAnalytics(value: object): value is WorkspaceAnalytics {
    if (!('comparisonsCount' in value) || value['comparisonsCount'] === undefined) return false;
    if (!('supplementsCount' in value) || value['supplementsCount'] === undefined) return false;
    if (!('claimsByStatus' in value) || value['claimsByStatus'] === undefined) return false;
    if (!('upcomingTasks' in value) || value['upcomingTasks'] === undefined) return false;
    if (!('recentActivities' in value) || value['recentActivities'] === undefined) return false;
    if (!('timeSavedComparisons' in value) || value['timeSavedComparisons'] === undefined) return false;
    if (!('timeSavedSupplements' in value) || value['timeSavedSupplements'] === undefined) return false;
    if (!('aiTimeComparisons' in value) || value['aiTimeComparisons'] === undefined) return false;
    if (!('aiTimeSupplements' in value) || value['aiTimeSupplements'] === undefined) return false;
    if (!('manualTimeComparisons' in value) || value['manualTimeComparisons'] === undefined) return false;
    if (!('manualTimeSupplements' in value) || value['manualTimeSupplements'] === undefined) return false;
    if (!('totalCarrierOverscope' in value) || value['totalCarrierOverscope'] === undefined) return false;
    if (!('totalMissedItems' in value) || value['totalMissedItems'] === undefined) return false;
    if (!('potentialCommission' in value) || value['potentialCommission'] === undefined) return false;
    if (!('totalInsuranceRCV' in value) || value['totalInsuranceRCV'] === undefined) return false;
    if (!('totalContractorRCV' in value) || value['totalContractorRCV'] === undefined) return false;
    if (!('totalRCVDifference' in value) || value['totalRCVDifference'] === undefined) return false;
    return true;
}

export function WorkspaceAnalyticsFromJSON(json: any): WorkspaceAnalytics {
    return WorkspaceAnalyticsFromJSONTyped(json, false);
}

export function WorkspaceAnalyticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceAnalytics {
    if (json == null) {
        return json;
    }
    return {
        
        'comparisonsCount': json['comparisonsCount'],
        'supplementsCount': json['supplementsCount'],
        'claimsByStatus': ((json['claimsByStatus'] as Array<any>).map(ClaimStatusCountFromJSON)),
        'upcomingTasks': ((json['upcomingTasks'] as Array<any>).map(ClaimTaskFromJSON)),
        'recentActivities': ((json['recentActivities'] as Array<any>).map(ActivityEventFromJSON)),
        'timeSavedComparisons': json['timeSavedComparisons'],
        'timeSavedSupplements': json['timeSavedSupplements'],
        'aiTimeComparisons': json['aiTimeComparisons'],
        'aiTimeSupplements': json['aiTimeSupplements'],
        'manualTimeComparisons': json['manualTimeComparisons'],
        'manualTimeSupplements': json['manualTimeSupplements'],
        'totalCarrierOverscope': json['totalCarrierOverscope'],
        'totalMissedItems': json['totalMissedItems'],
        'potentialCommission': json['potentialCommission'],
        'totalInsuranceRCV': json['totalInsuranceRCV'],
        'totalContractorRCV': json['totalContractorRCV'],
        'totalRCVDifference': json['totalRCVDifference'],
        'averageVarianceAmount': json['averageVarianceAmount'] == null ? undefined : json['averageVarianceAmount'],
        'averageVariancePercent': json['averageVariancePercent'] == null ? undefined : json['averageVariancePercent'],
    };
}

export function WorkspaceAnalyticsToJSON(json: any): WorkspaceAnalytics {
    return WorkspaceAnalyticsToJSONTyped(json, false);
}

export function WorkspaceAnalyticsToJSONTyped(value?: WorkspaceAnalytics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comparisonsCount': value['comparisonsCount'],
        'supplementsCount': value['supplementsCount'],
        'claimsByStatus': ((value['claimsByStatus'] as Array<any>).map(ClaimStatusCountToJSON)),
        'upcomingTasks': ((value['upcomingTasks'] as Array<any>).map(ClaimTaskToJSON)),
        'recentActivities': ((value['recentActivities'] as Array<any>).map(ActivityEventToJSON)),
        'timeSavedComparisons': value['timeSavedComparisons'],
        'timeSavedSupplements': value['timeSavedSupplements'],
        'aiTimeComparisons': value['aiTimeComparisons'],
        'aiTimeSupplements': value['aiTimeSupplements'],
        'manualTimeComparisons': value['manualTimeComparisons'],
        'manualTimeSupplements': value['manualTimeSupplements'],
        'totalCarrierOverscope': value['totalCarrierOverscope'],
        'totalMissedItems': value['totalMissedItems'],
        'potentialCommission': value['potentialCommission'],
        'totalInsuranceRCV': value['totalInsuranceRCV'],
        'totalContractorRCV': value['totalContractorRCV'],
        'totalRCVDifference': value['totalRCVDifference'],
        'averageVarianceAmount': value['averageVarianceAmount'],
        'averageVariancePercent': value['averageVariancePercent'],
    };
}

